import { faEnvelope, faMapMarkedAlt, faPhoneAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { getMapApi } from '../../../../Api/Utils/apiUtils'
import SupplierMap from '../SupplierMap/SupplierMap'
import './SupplierDetails.css'

const SupplierDetails = ({lat, lng, email, phone, name, address}) => {
    return (
        <div className="supplier-content">
            {(lat && lng) &&
                <SupplierMap isMarkerShown 
                googleMapURL={getMapApi()}
                loadingElement={<div style={{ width: `100px` }} />}
                containerElement={<div style={{ height: `150px` }} />}
                mapElement={<div style={{ height: `100%` }} />} latt={lat} lngg={lng} name={name} />
            }
            {address &&
                <p style={{marginTop:"15px"}}><FontAwesomeIcon icon={faMapMarkedAlt} /> {address}</p>
            }
            {email &&
                <p><FontAwesomeIcon icon={faEnvelope} /> {email}</p>
            }
            {phone &&
                <p><FontAwesomeIcon icon={faPhoneAlt} /> {phone}</p>
            }
        </div>
    )
}

export default SupplierDetails
